exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-overlay p {\r\n    padding-right: 30px;\r\n}\r\n\r\n.modal-overlay .button-actions {\r\n    margin-top: 20px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/components/common/MergeCustomerModal.css
// module id = 611
// module chunks = 0